import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=fa412ea0&scoped=true&"
import script from "./Tour.vue?vue&type=script&lang=js&"
export * from "./Tour.vue?vue&type=script&lang=js&"
import style0 from "./Tour.vue?vue&type=style&index=0&id=fa412ea0&scoped=true&lang=css&"
import style1 from "./Tour.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa412ea0",
  null
  
)

export default component.exports